import type { FC, ReactNode } from 'react'

interface CtaLabelProps {
    text: string
}

interface CtaIconProps {
    src: string
    width: number
    height: number
}

// Splits a label into per-character spans so the stylesheet can run the rolling hover on each letter.
export const CtaLabel: FC<CtaLabelProps> = ({ text }): ReactNode => {
    return (
        <span className='cta-label'>
            {Array.from(text).map((char, index) => (
                <span key={index} className='cta-char'>
                    {char}
                </span>
            ))}
        </span>
    )
}

export const CtaIcon: FC<CtaIconProps> = ({ src, width, height }): ReactNode => {
    return (
        <span className='cta-icon-outer'>
            <img className='cta-icon' src={src} alt='' width={width} height={height} />
        </span>
    )
}

export const ChevronIcon: FC = (): ReactNode => <CtaIcon src='/images/ui/chevron-right.svg' width={6} height={11} />

export const ChevronWhiteIcon: FC = (): ReactNode => <CtaIcon src='/images/work/chevron-white.svg' width={6} height={11} />

export const ArrowIcon: FC = (): ReactNode => <CtaIcon src='/images/work/arrow-16.svg' width={16} height={16} />
